import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../AbstractElements";
import CommonCardHeader from "../CommonComponents/CommonCardHeader/CommonCardHeader";
import ClientBoxGrid from "./ClientBoxGrid";
import CreateClientModal from "../UiKits/Modal/ClientProfile/Create";

const ClientProfileContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="Client Profile" parent="Administrator" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <CreateClientModal />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <ClientBoxGrid />
        </Row>
      </Container>
    </>
  );
};

export default ClientProfileContainer;
